import { IRootState } from '../../../../store'
import { IAssessmentState } from '../store/assessment.types'
export const getAssessmentSelector = (state: IRootState): IAssessmentState => state.assessment
